var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:{ next: _vm.type === 'next', back: _vm.type !== 'next' },attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.advance}},[(_vm.loading)?_c('div',{staticClass:"spinner-border spinner-border-sm mr-2 text-primary"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.loading ? "Processing..." : _vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }